import React, { useState } from "react";

const PasswordInput = ({ 
  name, 
  placeholder, 
  value, 
  onChange, 
  autoComplete = "current-password",
  invalid,
  "data-error": dataError
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="password-wrapper">
      <input
        type={showPassword ? "text" : "password"}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        invalid={invalid}
        data-error={dataError}
      />
      <div
        className="eyeContainer"
        onClick={() => setShowPassword(prev => !prev)}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setShowPassword(prev => !prev)}
        role="button"
        tabIndex={0}
        aria-label="Afficher ou masquer le mot de passe"
      >
        <i className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"} eye-icon`} />
      </div>
    </div>
  );
};

export default PasswordInput;
